import { Box, Chip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { acceptFinallyStatus, documentStatus, sabtNahayiStatus } from 'src/enumeration';
import EProfile from 'src/pages/profiles/enum';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { fDateTime } from '../../../utils/formatTime';
import Enum from '../enum';
import { PASSPORT_SENDING_STATUS, PASSPORT_SENDING_STATUS_FILTER } from 'src/config';

export const tableData = () => [
  // {
  //   key: 'name',
  //   header: 'نام',
  //   Component: ({ param }) => param?.client?.name || '-',
  // },
  // {
  //   key: 'lastName',
  //   header: 'نام خانوادگی',
  //   Component: ({ param }) => param?.client?.last_name || '-',
  // },
  {
    key: 'name',
    header: 'نام و نام خانوادگی',
    Component: ({ param }) =>
      // param?.client?.name || param?.client?.last_name ? (
      param?.client?.id ? (
        <Box
        >
          <Box sx={{ color: 'grey.900' }}>{`${param?.client?.name || '-'} ${param?.client?.last_name || '-'} ${
            param?.members > 1 ? `(${param?.members})` : ''
          }`}</Box>
        </Box>
      ) : (
        '-'
      ),
  },
  {
    key: 'nationalCode',
    header: 'کدملی',
    Component: ({ param }) => param?.client?.code_melli || '-',
  },
  {
    key: 'phone',
    header: 'تلفن همراه',
    Component: ({ param }) => param?.client?.phone || '-',
  },
  // {
  //   key: 'shenasname_number',
  //   header: 'شماره شناسنامه',
  //   Component: ({ param }) => param?.client?.shenasname_number || '-',
  // },
  // {
  //   key: 'reason',
  //   header: 'تشرف به صورت',
  //   Component: ({ param }) => param?.travel?.name || '-',
  // },
  {
    key: 'status',
    header: 'اولویت اعزام',
    // filter: {
    //   lookup: Object.values(acceptFinallyStatus),
    //   multiple: true,
    // },
    Component: ({ param }) => <Chip label={param?.status} color={Enum.status.object[param?.status_num]?.color} />,
  },
];
